import { render, staticRenderFns } from "./dialogSpinner.component.vue?vue&type=template&id=72a7e98a&scoped=true&"
import script from "./dialogSpinner.component.vue?vue&type=script&lang=js&"
export * from "./dialogSpinner.component.vue?vue&type=script&lang=js&"
import style0 from "./dialogSpinner.component.vue?vue&type=style&index=0&id=72a7e98a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a7e98a",
  null
  
)

export default component.exports